import $ from '../../../../js/alias/jquery'
import ModalAlert from '../../../../js/components/modalAlert/ModalAlert'
import messageResource from '../../../../js/messageResource'
import {ModalAlertPointerPosition} from '../../../../js/components/modalAlert/constants'
import View from '../../../../js/View'
import {connect} from '../../../../js/redux/utils'
import {regenerateFeedUrl} from '../actions'
import {bindActionCreators} from 'redux'
import {isUserActionLoading} from '../selectors'

class ICalRegenerateDialog extends View {
    constructor({
        regenerateFeedUrl = () => {},
    }) {
        super()

        this.state = {
            iCalSettingsId: 0,
            loading: false,
        }

        this.actions = {
            regenerateFeedUrl,
        }

        this.onStatePropertyChanged('loading', loading => this.modalAlert.setState({loading}))
    }

    afterRender() {
        this.modalAlert = new ModalAlert({
            showCancelButton: true,
            okButtonLabel: messageResource.getMessage('icalendar.dialog.regenerate.ok'),
            returnToInitialPosition: false,
            onConfirm: () => this.actions.regenerateFeedUrl(this.state.iCalSettingsId, () => this.modalAlert.hide()),
            withLoading: true,
        }).init($('body'))

        this.modalAlert.setState({
            header: messageResource.getMessage('icalendar.dialog.regenerate.header'),
            text: messageResource.getMessage('icalendar.dialog.regenerate.content'),
            additionalClass: 'iCalRegenerateDialog',
            pointerPosition: ModalAlertPointerPosition.RIGHT,
            offsets: {
                left: 19,
                top: 0,
            },
        })
    }

    showAt(element, onHideCb) {
        this.modalAlert.showAt(element, onHideCb)
    }
}

const ICalRegenerateDialogConnected = connect(
    state => ({
        loading: isUserActionLoading(state),
    }),
    dispatch => ({
        regenerateFeedUrl: bindActionCreators(regenerateFeedUrl, dispatch),
    })
)(ICalRegenerateDialog)

let instance = null
export const getRegenerateDialog = () => {
    if (!instance) {
        instance = new ICalRegenerateDialogConnected().init()
    }
    return instance
}



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/dialogs/RegenerateLinksDialog.js